import { render } from "./dividerLine.vue?vue&type=template&id=a5b35c50&scoped=true"
import script from "./dividerLine.vue?vue&type=script&lang=js"
export * from "./dividerLine.vue?vue&type=script&lang=js"

import "./dividerLine.vue?vue&type=style&index=0&id=a5b35c50&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b35c50"]])

export default __exports__